// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Editor_header__1fqKF {
  display: flex;
  justify-content: space-between;
}

.Editor_title__cGqXT {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.Editor_input__-dZBH,
.Editor_input__-dZBH .ant-select-selector {
  background-color: #fbfbfb !important;
  border-color: #d2d2d2 !important;
  border-radius: 4px !important;
}

.Editor_labelFormItem__hIYsK {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}

.Editor_labelFormItemBackup__SRd04 {
  font-weight: 500;
  color: var(--orange);
  font-size: 12px;
}

.Editor_scheduledActive__fjhP\\+ {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.Editor_scheduleTime__ZuHIQ {
  width: 559px;
  margin-top: 20px;
  border-radius: 8px;
  border: 1px solid #cbcbcb;
  padding: 15px;
}

.Editor_headerScheduleTime__ecASQ {
  display: flex;
  justify-content: space-between;
}

.Editor_labelHeaderScheduleTime__XNLzQ {
  font-size: 12px;
  font-weight: 600;
}

.Editor_actionHeaderScheduleTime__6oCwO {
  display: flex;
  gap: 10px;
}

.Editor_week__ZFkCA {
  display: flex;
  justify-content: center;
  gap: 50px;
  margin-top: 10px;
}

.Editor_day__\\+520u {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f5f8ff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.Editor_activeDay__RXqHS {
  background-color: #9e3223;
  color: #fff;
}

.Editor_currentDay__c6U7U {
  background-color: var(--orange);
  color: #fff;
}

.Editor_selectedDayContainer__DriA5 {
  display: flex;
  margin-top: 20px;
  gap: 10px;
}

.Editor_selectedDay__1llgo {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 10px;
}

.Editor_divider__rjWVr {
  display: flex;
  width: 425px;
  height: 1px;
  border: 1px solid #adadad;
}

.Editor_saveDateTimeButton__-V5yP {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #626262;
  width: 157px;
  height: 40px;
  padding: 4px;
  gap: 4px;
  border-radius: 50px;
  border: 1px solid var(--orange);
}

.Editor_deleteIcon__s6PMs{
  cursor: pointer;
}

.Editor_containerDateEnd__-pRiV {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.Editor_selectedDate__DfWPv {
  display: flex;
  flex-direction: column;
}

.Editor_datePicker__\\+ehqf{
  width: 250px;
}

.Editor_containerSubmitButton__Qni\\+O {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.Editor_submitButton__HDZKK {
  width: 200px;
  font-weight: 700;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/emergency-branch/styles/Editor.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AACA;EACI,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AACF;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,+BAA+B;AACjC;;AACA;EACI,eAAe;AACnB;;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AACA;EACE,YAAY;AACd;;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n}\n.title {\n    color: var(--darkGray);\n    font-family: BebasNeue;\n    font-weight: 700;\n    font-size: 20px;\n  }\n.input,\n.input :global(.ant-select-selector) {\n  background-color: #fbfbfb !important;\n  border-color: #d2d2d2 !important;\n  border-radius: 4px !important;\n}\n\n.labelFormItem {\n  font-weight: 500;\n  color: var(--darkGray);\n  font-size: 12px;\n}\n\n.labelFormItemBackup {\n  font-weight: 500;\n  color: var(--orange);\n  font-size: 12px;\n}\n\n.scheduledActive {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n\n.scheduleTime {\n  width: 559px;\n  margin-top: 20px;\n  border-radius: 8px;\n  border: 1px solid #cbcbcb;\n  padding: 15px;\n}\n\n.headerScheduleTime {\n  display: flex;\n  justify-content: space-between;\n}\n.labelHeaderScheduleTime {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.actionHeaderScheduleTime {\n  display: flex;\n  gap: 10px;\n}\n\n.week {\n  display: flex;\n  justify-content: center;\n  gap: 50px;\n  margin-top: 10px;\n}\n\n.day {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-color: #f5f8ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.activeDay {\n  background-color: #9e3223;\n  color: #fff;\n}\n\n.currentDay {\n  background-color: var(--orange);\n  color: #fff;\n}\n\n.selectedDayContainer {\n  display: flex;\n  margin-top: 20px;\n  gap: 10px;\n}\n\n.selectedDay {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 10px;\n}\n\n.divider {\n  display: flex;\n  width: 425px;\n  height: 1px;\n  border: 1px solid #adadad;\n}\n\n.saveDateTimeButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #626262;\n  width: 157px;\n  height: 40px;\n  padding: 4px;\n  gap: 4px;\n  border-radius: 50px;\n  border: 1px solid var(--orange);\n}\n.deleteIcon{\n    cursor: pointer;\n}\n.containerDateEnd {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.selectedDate {\n  display: flex;\n  flex-direction: column;\n}\n.datePicker{\n  width: 250px;    \n}\n.containerSubmitButton {\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n}\n.submitButton {\n  width: 200px;\n  font-weight: 700;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Editor_header__1fqKF`,
	"title": `Editor_title__cGqXT`,
	"input": `Editor_input__-dZBH`,
	"labelFormItem": `Editor_labelFormItem__hIYsK`,
	"labelFormItemBackup": `Editor_labelFormItemBackup__SRd04`,
	"scheduledActive": `Editor_scheduledActive__fjhP+`,
	"scheduleTime": `Editor_scheduleTime__ZuHIQ`,
	"headerScheduleTime": `Editor_headerScheduleTime__ecASQ`,
	"labelHeaderScheduleTime": `Editor_labelHeaderScheduleTime__XNLzQ`,
	"actionHeaderScheduleTime": `Editor_actionHeaderScheduleTime__6oCwO`,
	"week": `Editor_week__ZFkCA`,
	"day": `Editor_day__+520u`,
	"activeDay": `Editor_activeDay__RXqHS`,
	"currentDay": `Editor_currentDay__c6U7U`,
	"selectedDayContainer": `Editor_selectedDayContainer__DriA5`,
	"selectedDay": `Editor_selectedDay__1llgo`,
	"divider": `Editor_divider__rjWVr`,
	"saveDateTimeButton": `Editor_saveDateTimeButton__-V5yP`,
	"deleteIcon": `Editor_deleteIcon__s6PMs`,
	"containerDateEnd": `Editor_containerDateEnd__-pRiV`,
	"selectedDate": `Editor_selectedDate__DfWPv`,
	"datePicker": `Editor_datePicker__+ehqf`,
	"containerSubmitButton": `Editor_containerSubmitButton__Qni+O`,
	"submitButton": `Editor_submitButton__HDZKK`
};
export default ___CSS_LOADER_EXPORT___;
